import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { BadgeAlert, ExternalLink } from 'lucide-react';
import { api } from '@/lib/api';

// V5.4 §8 — TalentTrain certificate expiration / recertification alerts
export const TtCertAlerts = () => {
  const { i18n } = useTranslation();
  const isES = (i18n.language || 'es').startsWith('es');
  const L = (es, en) => (isES ? es : en);
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get('/client/talenttrain/cert-alerts').then((r) => setData(r.data)).catch(() => setData({ items: [] }));
  }, []);
  if (!data || data.items.length === 0) return null;
  return (
    <Card className="p-5 shadow-card" data-testid="tt-cert-alerts-card">
      <div className="flex items-center gap-2 mb-3">
        <BadgeAlert className="h-4 w-4 text-orange-600" />
        <p className="text-base font-semibold">{L('Constancias por recertificar', 'Certificates to recertify')}</p>
        <Badge variant="outline" className="text-xs bg-red-50 text-red-700 border-red-200">{data.counts.expired} {L('vencidas', 'expired')}</Badge>
        <Badge variant="outline" className="text-xs bg-orange-50 text-orange-700 border-orange-200">{data.counts.expiring_soon} {L('por vencer', 'expiring soon')}</Badge>
      </div>
      <p className="text-xs text-muted-foreground mb-3" data-testid="tt-cert-alerts-hint">
        {L('La vigencia de una constancia es independiente del estado de la acción formativa: adjuntar una constancia no marca la acción como completada.',
           'Certificate validity is independent of training-action status: attaching a certificate does not mark the action as completed.')}
      </p>
      <div className="space-y-2">
        {data.items.map((i) => (
          <div key={i.document_id} className="flex items-center gap-2 rounded-md border px-3 py-2 text-sm flex-wrap" data-testid={`tt-cert-alert-${i.document_id}`}>
            <div className="min-w-0 flex-1">
              <p className="font-medium truncate">{i.document_name}</p>
              <p className="text-xs text-muted-foreground truncate">{i.employee_name} · {i.action_name}</p>
            </div>
            <span className={`text-xs font-medium ${i.state === 'expired' ? 'text-red-600' : 'text-orange-600'}`}>
              {i.state === 'expired' ? L('venció', 'expired') : L('vence', 'expires')} {i.expiration_date}
            </span>
            {i.employee_id && (
              <Button size="sm" variant="outline" onClick={() => navigate(`/client/talenttrain/${i.employee_id}?action=${i.action_id}`)}
                      data-testid={`tt-cert-open-${i.document_id}`}>
                <ExternalLink className="h-3.5 w-3.5 mr-1" />{L('Ver acción', 'View action')}
              </Button>
            )}
          </div>
        ))}
      </div>
    </Card>
  );
};
